import { useArbitrage } from '@/helpers/composables/useArbitrage';
import { useMounted } from '@vueuse/core';
import { computed } from 'vue';
import type { TitleDetail } from '@/interfaces/title-details-graphql';

export function useJWTVCampaign() {
	const { arbitration } = useArbitrage();

	const isMounted = useMounted();

	const hasActiveJwtvCampaign = computed(() => {
		const jwtvCampaignParam = arbitration.value?.utm_campaign;
		return isMounted.value && !!jwtvCampaignParam?.toLowerCase().includes('jwtv');
	});

	function getPromotedOffersWithJwtv<T extends { package: { shortName: string } }>(
		promotedOffers: T[],
		title: TitleDetail
	): T[] {
		if (!hasActiveJwtvCampaign.value) {
			return promotedOffers;
		}

		const hasJWTVOffer = promotedOffers?.some(offer => offer.package.shortName === 'jwt');
		if (!hasJWTVOffer) {
			const { rent } = title;
			const jwtvOffer = rent?.find(offer => offer.package.shortName === 'jwt');
			if (jwtvOffer) {
				return [jwtvOffer as unknown as T];
			}
		}

		return promotedOffers;
	}

	return {
		hasActiveJwtvCampaign,
		getPromotedOffersWithJwtv,
	};
}
